import Vue from 'vue';
import Vuex from 'vuex';
import { PortalState } from './modules/portal';

Vue.use(Vuex);

export interface MyRootState {
  portal: PortalState;
}
export default new Vuex.Store<MyRootState>({});